import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView/index.vue'
import { getToken } from '@/utils/token.js'
import { Message } from 'element-ui'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
    // 重定向
    {
        path: "/",
        redirect: "/home"
    },
    // 首页
    {
        path: '/home',
        name: 'home',
        component: HomeView,
        meta: {
            show: true,
            isFooter: true,
            isHeader: false
        }
    },
    // 个人账户
    {
        path: '/individualAccount',
        component: () =>
            import('@/views/individualAccount/index.vue'),
        children: [{
            path: 'rightMenu',
            name: 'rightMenu',
            component: () =>
                import('@/views/individualAccount/compoents/right-menu.vue'),

            // 个人中心 ---> 车辆管理
            // children: [{
            //     path: 'rightCom/:routeID:carId',
            //     name: 'rightCom',
            //     component: () =>
            //         import('@/views/VehicleManagement/index.vue'),

            // },]
        },]
    },
    // 登陆页面
    {
        path: '/loginPage',
        component: () =>
            import('@/views/LoginRegister/LoginPage/index.vue'),
        meta: {
            show: true,
            isHeader: true

        }
    },

    //注册页面
    {
        path: '/enroll',
        component: () =>
            import('@/views/LoginRegister/Enroll/index.vue'),
        meta: {
            show: true,
            isHeader: false
        }
    },


    // 拍卖会
    {
        path: '/auction',
        component: () =>
            import('@/views/Auction/index.vue'),
        meta: {
            show: true,
            isFooter: true,
            isHeader: false
        }
    },
    // app下载
    {
        path: '/appDownload',
        component: () =>
            import('@/views/AppDownload/index.vue'),
        meta: {
            show: true,
            isHeader: false
        }
    },
    // 帮助中心
    {
        path: '/helpCenter',
        component: () =>
            import('@/views/HelpCenter/index.vue'),
        meta: {
            show: true,
            isFooter: true,
            isHeader: false
        }
    },
    // 关于我们
    {
        path: '/aboutUs',
        component: () =>
            import('@/views/AboutUs/index.vue'),
        meta: {
            show: true,
            isFooter: true,
            isHeader: false
        }
    },
    // AuctionDetails
    // 车辆拍卖详情
    {
        path: '/CardDetails',
        component: () =>
            import('@/views/CardDetails/CardDetails/index.vue'),
        meta: {
            show: true,
            isHeader: false
        }
    },
    // 车辆详情
    {
        path: '/VehicleDetails',
        component: () =>
            import('@/views/VehicleDetails/VehicleDetails/index.vue'),
        meta: {
            show: true,
            isHeader: false
        }
    },

    // 拍卖会
    {
        path: '/ScheduledVehicle',
        component: () =>
            import('@/views/HomeView/components/scheduledVehicle/index.vue'),
        meta: {
            show: true,
            isHeader: false
        }
    },
    // 测试页面
    // {
    //     path: '/test',
    //     component: () =>
    //         import('@/views/test/index.vue'),
    //     meta: {
    //         show: true,
    //         isHeader: false
    //     }
    // },

    // 404
    {
        path: '*',
        component: () =>
            import('@/components/404/index.vue'),
        meta: {
            isFooter: false,
            isHeader: true
        }
    }
]

const originalPush = VueRouter.prototype.push
// 重写原型上的push方法，统一处理错误信息
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    // 路由滚动
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})


// to表示去哪个路由，from表示来自哪个路由，next表示放行
router.beforeEach((to, from, next) => {
    let token = getToken()
    if (to.path !== '/loginPage' && !to.meta.show && !token) {
        Message.warning('请先登录')
        next('/');
        // 刷新页面


        store.commit("HANLE_VISIBLE_DIALOG", true);
    } else {
        next(); // 如果用户已经在登录页面或者已经登录，放行
    }
})
export default router